import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import {
  Box,
  Typography,
  Stack,
  TextField,
  InputAdornment,
  IconButton,
  CircularProgress,
  Alert,
  Paper,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Tooltip
} from "@mui/material";

import SearchIcon from "@mui/icons-material/Search";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import LocationOnIcon from "@mui/icons-material/LocationOn";

import ModalUbicacion from "../componentes/modalubicacion"; // Modal separado

export default function UbicacionesPage() {
  const [ubicaciones, setUbicaciones] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [search, setSearch] = useState("");
  const [empresaId, setEmpresaId] = useState(null);

  const API_LISTAR = "https://demo.datachile.site/API/web/obtener_lugares.php";
  const API_ELIMINAR = "https://demo.datachile.site/API/web/eliminar_lugar.php";

  useEffect(() => {
    const storedUser = localStorage.getItem("usuario");
    if (storedUser) setEmpresaId(JSON.parse(storedUser).empresa_idempresa);
  }, []);

  useEffect(() => {
    if (empresaId) listarUbicaciones();
  }, [empresaId]);

  const listarUbicaciones = async () => {
    try {
      setLoading(true);
      const res = await axios.get(API_LISTAR, { params: { empresa_idempresa: empresaId } });
      setUbicaciones(res.data);
    } catch (err) {
      console.error(err);
      setError("Error al cargar ubicaciones");
    } finally {
      setLoading(false);
    }
  };

  const eliminarUbicacion = async (idLugar) => {
    if (!window.confirm("¿Eliminar ubicación?")) return;

    try {
      await axios.post(API_ELIMINAR, { idLugar, empresa_idempresa: empresaId });
      listarUbicaciones();
    } catch (err) {
      console.error(err);
      setError("Error al eliminar ubicación");
    }
  };

  const filteredData = useMemo(() => {
    return ubicaciones.filter((u) =>
      u.lugar.toLowerCase().includes(search.toLowerCase())
    );
  }, [ubicaciones, search]);

  return (
    <Box sx={{ p: 3 }}>
      {/* HEADER */}
      <Stack
        direction={{ xs: "column", md: "row" }}
        justifyContent="space-between"
        alignItems="center"
        spacing={2}
        sx={{ mb: 3 }}
      >
        <Box>
          <Typography variant="h4" fontWeight={700}>
            Ubicaciones
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Administración y gestión de ubicaciones de tu sistema
          </Typography>
        </Box>

        <Stack direction="row" spacing={2}>
          <TextField
            size="small"
            placeholder="Buscar ubicación..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
          <ModalUbicacion empresaId={empresaId} actualizarTabla={listarUbicaciones} />
        </Stack>
      </Stack>

      {/* ERROR */}
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

      {/* LOADING */}
      {loading ? (
        <Box display="flex" justifyContent="center" mt={4}>
          <CircularProgress />
        </Box>
      ) : (
        <TableContainer
          component={Paper}
          sx={{
            borderRadius: 3,
            overflow: "hidden",
            boxShadow: "0 4px 20px rgba(0,0,0,0.05)"
          }}
        >
          <Table>
            <TableHead>
              <TableRow sx={{ background: "linear-gradient(90deg, #1976d2, #42a5f5)" }}>
                <TableCell sx={{ color: "#fff", fontWeight: 600 }}>ID</TableCell>
                <TableCell sx={{ color: "#fff", fontWeight: 600 }}>Ubicación</TableCell>
                <TableCell sx={{ color: "#fff", fontWeight: 600 }}>EPC</TableCell>
                <TableCell sx={{ color: "#fff", fontWeight: 600 }}>Acciones</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {filteredData.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={4} align="center">
                    No se encontraron ubicaciones
                  </TableCell>
                </TableRow>
              ) : (
                filteredData.map((u) => (
                  <TableRow
                    key={u.idLugar}
                    sx={{ "&:hover": { backgroundColor: "rgba(25, 118, 210, 0.08)" } }}
                  >
                    <TableCell>{u.idLugar}</TableCell>
                    <TableCell>{u.lugar}</TableCell>
                    <TableCell>{u.epc}</TableCell>
                    <TableCell>
                      <Stack direction="row" spacing={1}>
                        <Tooltip title="Eliminar">
                          <IconButton
                            color="error"
                            onClick={() => eliminarUbicacion(u.idLugar)}
                          >
                            <DeleteForeverIcon />
                          </IconButton>
                        </Tooltip>
                      </Stack>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
}